(function (angular) {
	'use strict';

	var scriptElement = document.getElementById('js-base-config-init');
	var googleRecaptchaSiteKey = scriptElement.getAttribute('data-google-recaptcha-site-key');
	
	angular
		.module('googleRecaptchaModule', [
			'vcRecaptcha'
		])
		.config([
			'vcRecaptchaServiceProvider',
			vcRecaptchaBaseConfigSetup
		]);

	function vcRecaptchaBaseConfigSetup(
		vcRecaptchaServiceProvider
	){
		vcRecaptchaServiceProvider.setDefaults({
			key: googleRecaptchaSiteKey,
			theme: 'light',
			size: 'invisible'
		});
	}
})(window.angular);